module.exports = __webpack_public_path__ + "img/composition.cecd8ad1.svg";